<ng-container *ngIf="mode == 'list'"> </ng-container>
<ng-template #top class="tyn-list">
  <ng-content select="[top]"></ng-content>
</ng-template>
<ng-template #list tynAd> </ng-template>
